import React from "react";
import { Link } from "react-router-dom";
import {
  constants,
  DateFormat,
} from "../../../Containers/Constants/commenFeatures";
// import youtubeImg from "../../assets/images/youtube.webp";

const VideosPage = ({ video }) => {
  return (
    <div className="articleWraps">
      <div></div>
      <div className="video_box">
        <iframe
          src={video.url}
          title="YouTube video player"
          frameborder="0"
          allowfullscreen
          allow="fullscreen"
        ></iframe>
      </div>
      <div className="infos vid_info">
        <Link to={`videos/${video.resourceId}`}>
          <h6>{video.name}</h6>
        </Link>
      </div>
      <div className="display-flex align-center articleWrapsInfo">
        <p className="date">
          {video ? DateFormat(video.date, constants.resourceDateFormat) : ""}
        </p>
        {/* <p>
          <a
            className="disabled"
            href={video.productLink ? video.productLink : "javascript:void(0)"}
          >
            Product
          </a>
        </p> */}
      </div>
    </div>
  );
};

export default VideosPage;
